import { render } from "./toughMinded.vue?vue&type=template&id=5a299155"
import script from "./toughMinded.vue?vue&type=script&lang=js"
export * from "./toughMinded.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__